import { getUserType } from './getUserUtil';
import { getPermissionsForRole } from './roles';

const getUserPermissions = (role_key) => {
  return getPermissionsForRole(role_key);
};
export const setupLogin = (role_key) => {
  return {
    user: getUserType(role_key),
    permissions: getUserPermissions(role_key)
  };
};
